import { useEffect, useState } from "react"
import axios from 'axios';
export default function useFetchWebinarData(alias) {
  const [ data, setData ] = useState(null)

  useEffect(() => {
    (
      async function(){
        try{
          const url = '/api/webinar/'
          const response = await axios.get(url + alias)
          setData(response.data)
        }catch(err){
          console.log(err)
        }
      }
    )()
  }, [alias])

  return data
}
